import script from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"

import "./ImageCropper.vue?vue&type=style&index=0&id=84db7acc&lang=css"

const __exports__ = script;

export default __exports__